module.exports = {
	"header": "404 - Page introuvable",
	"ln1": "Oups! La page demandée ne semble pas exister!",
	"ln2": "Le lien qui vous a mené ici a expiré ou est invalide."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/404.json5
// module id = 1967
// module chunks = 6